export default __webpack_public_path__ + "static/media/toggle-on.9ccd7d68.svg";